import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
  answerBlock
} from 'actions';

import Question from 'components/Questionnaires/Question';
import { QuestionTextField, QuestionYesNoField } from 'components/Questionnaires/fields';
import { normalizeFullWidth } from 'components/Common/Inputs';
import CollapsibleHeader from 'components/Questionnaires/CollapsibleHeader';

export const QuestionForeignTinBlock = ({ block }) => {
  const dispatch = useDispatch();
  const [answer, setAnswer] = useState(block?.answers ?? { notRequired: false });
  const [collapsibleAreaShown, setCollapsibleAreaShown] = useState(false);

  const [tin, setTin] = useState({
    id: 'tin',
    label: 'questionnaire.foreignTin.tin.label',
    component: QuestionTextField,
    componentProps: { normalize: normalizeFullWidth, maxLength: 60 },
    info: block?.componentProps?.info ?? {
      instructions: 'questionnaire.foreignTin.info'
    },
    visible: true,
  });

  const notRequired = {
    id: 'notRequired',
    label: 'questionnaire.foreignTin.notRequired.label',
    component: QuestionYesNoField,
    default: 'No',
    visible: true,
  };

  const blockIdentifier = useMemo(() => ((block && block.id) ? `${ block.id }${ block.index !== undefined ? (`.${ block.index }`) : '' }` : undefined), [block.index]);

  useEffect(() => {
    dispatch(answerBlock(block.id, answer, true));
  }, [answer]);

  useEffect(() => {
    setAnswer(block.answers ?? {});
  }, [block.answers]);

  const onQuestionChange = (q, value) => {
    switch (q.id) {
      case 'tin': {
        setAnswer({ ...answer, tin: value });
        break;
      }
      case 'notRequired': {
        const newComponentProps = { ...tin.componentProps, disabled: value === 'Yes' };
        setTin({ ...tin, componentProps: newComponentProps });
        setAnswer({ ...answer, notRequired: value });
        break;
      }
      default:
        break;
    }
  };

  // Uncomment useEffect below if any questions have validation added to it.
  /* useEffect(() => {
  }, [block.isForceEdited]); */

  return (<React.Fragment>
    <Question key={ tin.id } blockId={ blockIdentifier } question={ tin } { ...tin.componentProps } onChange={ (q, a) => onQuestionChange(q, a) } />
    <div className="col-12">
      <CollapsibleHeader isShown={ collapsibleAreaShown } onExpandCollapse={ value => setCollapsibleAreaShown(value) } text="questionnaire.foreignTin.moreOptions" />
      { collapsibleAreaShown && <Question key={ notRequired.id } blockId={ blockIdentifier } question={ notRequired } { ...notRequired.componentProps } onChange={ (q, a) => onQuestionChange(q, a) } /> }
    </div>
  </React.Fragment>);
};

QuestionForeignTinBlock.displayName = 'QuestionForeignTinBlock';

QuestionForeignTinBlock.propTypes = {
  block: PropTypes.shape().isRequired
};

QuestionForeignTinBlock.defaultProps = {
};

export default QuestionForeignTinBlock;
